var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.97111 39.5565C1.39167 38.9771 1.39167 38.0376 1.97111 37.4581L37.9711 1.45815C38.5506 0.878699 39.49 0.8787 40.0695 1.45814C40.6489 2.03759 40.6489 2.97706 40.0695 3.5565L4.06947 39.5565C3.49003 40.1359 2.55056 40.1359 1.97111 39.5565Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.97112 1.45787C2.55056 0.878425 3.49003 0.878425 4.06947 1.45787L40.0695 37.4579C40.6489 38.0373 40.6489 38.9768 40.0695 39.5562C39.49 40.1357 38.5506 40.1357 37.9711 39.5562L1.97112 3.55623C1.39167 2.97678 1.39167 2.03731 1.97112 1.45787Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.981a0d258a11ce3e1eb8f68352899906.svg";
export { ForwardRef as ReactComponent };